import React from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { CustomTooltip } from '../Tooltip/Tooltip';
import { noOverflow } from '../../../themes/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import KababMenuHorizontal from '../Menu/KababMenuHorizontal';

const useStyles = makeStyles((theme: any) => ({
  productContent: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  image: {
    marginRight: theme.spacing(1.5),
    borderRadius: '100%',
    height: 32,
    width: 32,
  },
  nameContainer: { ...(noOverflow as object) },
  name: {
    fontWeight: 'bold',
    display: 'inline-block',
    maxWidth: '100%',
    cursor: 'default',
  },
  group: { color: theme.palette.brand.greenNature, textAlign: 'left' },
  actions: { marginLeft: 'auto', marginRight: theme.spacing(0.5) },
}));

const GROUP = 'Product group';

export default function Product({
  image,
  name,
  actions = null,
  lineOnEditMode,
}) {
  const mobile = useMobile('sm');
  const classes = useStyles();

  return (
    <div className={classes.productContent}>
      <Avatar alt={name + ' image'} src={image} className={classes.image}>
        {!image && <Typography>{name?.slice(0, 1)?.toUpperCase()}</Typography>}
      </Avatar>
      <CustomTooltip
        arrow
        title={<Typography>{name}</Typography>}
        placement="top"
      >
        <div className={classes.nameContainer}>
          <Typography className={classes.name}>{name}</Typography>
          {mobile && (
            <Typography variant="body2" className={classes.group}>
              {GROUP}
            </Typography>
          )}
        </div>
      </CustomTooltip>
      {actions && (
        <div className={classes.actions}>
          <KababMenuHorizontal actions={actions} disabled={lineOnEditMode} />
        </div>
      )}
    </div>
  );
}
